/**
 * org模块路由
 * Created by kb on 2017/09/04.
 */
import _import from './_import_development'

export  default {
  path: '/report',
  name: 'report',
  component: _import("Home"),
  meta: {permission: false},
  children: [
    { path: 'customerInformationList',component:_import("report/CustomerInformationList"),name:'客户信息表'},
    { path: 'orderInformationList',component:_import("report/OrderInformationList"),name:'订单明细表'},
    { path: 'orderTXList',component:_import("report/OrderTXList"),name:'特许订单明细表'},
    { path: 'orderTXHZList',component:_import("report/OrderTXHZList"),name:'特许订单汇总表'},
    { path: 'qMDZList',component:_import("report/QMDZList"),name:'期末对账表'},
    { path: 'SelsMonthByCustomer',component:_import("report/SelsMonthByCustomer"),name:'客户月销量报表'},
    { path: 'SelsByArea',component:_import("report/SelsByArea"),name:'地区销量报表'},
    { path: 'SalesDepartmentDay',component:_import("report/SalesDepartmentDay"),name:'部门日销量总表'},
    { path: 'SalesGoods',component:_import("report/SalesGoods"),name:'销售分析（按商品分类）'},
    { path: 'SalesCustomer',component:_import("report/SalesCustomer"),name:'销售分析（按客户）'},
    { path: 'SalesMonth',component:_import("report/SalesMonth"),name:'客户月销量报表'},
    { path: 'CustomerBuyPlan',component:_import("report/CustomerBuyPlan"),name:'客户采购计划表'},
    { path: 'StatisticalTable',component:_import("report/StatisticalTable"),name:'汇总统计表'},
  ]
}




// WEBPACK FOOTER //
// ./src/router/report.js